import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from "../../utils";

gsap.registerPlugin(ScrollTrigger);

const DESKTOP_BREAKPOINT = 767;
const LARGE_SCREEN_BREAKPOINT = 1024;
const DESKTOP_OFFSET = 30;
const MOBILE_OFFSET = 10;

class PageCreatorStackHorizontalScroll {
    constructor(parent) {
        this.parent = parent;
        this.prevWidth = window.innerWidth;

        this.stickyEl = document.querySelector('.creator-stack-horizontal-slider--sticky');
        this.stickyElWrapper = this.stickyEl.querySelector('.creator-stack-slider-wrapper');
        this.swiperSlide = [...this.stickyEl.querySelectorAll('.slide')];
        this.header = document.getElementById('header');
        this.cardsWidth = this.getCardsWidth();

        this.initCalculateStickyBasedOnScreenHeight = this.initCalculateStickyBasedOnScreenHeight.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.initResizing = this.initResizing.bind(this);

        this.initCalculateStickyBasedOnScreenHeight();
        this.initResizing();
    }

    initCalculateStickyBasedOnScreenHeight() {
        const { offsetWidth: wrapperWidth } = this.stickyElWrapper;
        this.wrapperWidth = wrapperWidth;

        const offsetHeader = this.header ? this.header.offsetHeight : 0;

        const baseOffset = window.innerHeight - this.stickyEl.offsetHeight - (window.innerWidth > DESKTOP_BREAKPOINT ? DESKTOP_OFFSET : MOBILE_OFFSET);
        let offset = this.stickyEl.offsetHeight < window.innerHeight
            ? baseOffset - (window.innerHeight - this.stickyEl.offsetHeight) / 2
            : baseOffset;

        if (window.innerWidth > LARGE_SCREEN_BREAKPOINT && window.innerHeight * 0.9 < this.stickyElWrapper.offsetHeight + offsetHeader) {
            offset -= (this.stickyElWrapper.offsetHeight - window.innerHeight) / 2;
        }

        this.stickyEl.style.top = `${offset}px`;

        gsap.defaults({ overwrite: 'auto' });

        this.tl?.scrollTrigger.kill();
        this.tl?.kill();

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.parent,
                start: `top top`,
                end: 'bottom-=10% 100%',
                preventOverlaps: true,
                fastScrollEnd: false,
                scrub: 0.5,
                immediateRender: false,
                invalidateOnRefresh: true,
            }
        })
            .to(this.swiperSlide, {
                x: `-=${this.cardsWidth - this.wrapperWidth - ( window.innerWidth > DESKTOP_BREAKPOINT ? DESKTOP_OFFSET : MOBILE_OFFSET ) * 2}`,
                ease: "none",
            });
    }

    handleResize() {
        if (this.prevWidth !== window.innerWidth || window.innerWidth > DESKTOP_BREAKPOINT) {
            this.prevWidth = window.innerWidth;
            this.cardsWidth = this.getCardsWidth();
            this.initCalculateStickyBasedOnScreenHeight();
            ScrollTrigger.refresh();
        }
    }

    getCardsWidth() {
        return this.swiperSlide.reduce((acc, slide) => acc + slide.offsetWidth, 0);
    }

    initResizing() {
        window.addEventListener('resize', debounce(this.handleResize, 200));
    }
}

export default PageCreatorStackHorizontalScroll;
